module.exports = __webpack_public_path__ + "fonts/Inter-400-greek28.3a3cf1a.woff2";